"use client"

import clsx from "clsx"

import { useGetCustomer } from "@unlikelystudio/react-ecommerce-hooks"

import { SectionTitle } from "~/components/ui/Account/components/SectionTitle"
import type { AccountInfomationsPage } from "~/components/ui/Account/templates/AccountInformationsTemplate/_data/serializer"
import { Spinner } from "~/components/abstracts/Spinner"
import { Stack } from "~/components/abstracts/Stack"
import { UpdateCustomerInformationsTemplate } from "~/components/forms/UpdateCustomerInformationsTemplate"
import { UpdatePasswordTemplate } from "~/components/forms/UpdatePasswordTemplate"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { capitalize } from "~/utils/capitalize"

import * as css from "./styles.css"

function ClientAccountInformations({ title, passwordLabel }: NonNullable<AccountInfomationsPage>) {
  const { data: customer } = useGetCustomer({ refetchOnMount: false })

  const t = useTranslate()

  return !customer ? (
    <Spinner />
  ) : (
    <Stack direction={"column"} gap={24} className={clsx(css.MyInformationsAccount)}>
      {title && <SectionTitle title={title} />}
      <UpdateCustomerInformationsTemplate className={css.updateInformations} />

      <Stack sprinklesCss={{ mT: { mobile: 25, desktop: 20 } }} direction={"column"} gap={6}>
        <h3 className={css.subSectionTitle}>{t("account_change_password")}</h3>
        {passwordLabel && <p className={css.subSectionLabel}>{capitalize(passwordLabel)}</p>}
      </Stack>

      <UpdatePasswordTemplate className={css.updatePassword} />
    </Stack>
  )
}

export { ClientAccountInformations }
